import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ADD_OFFICETIME, API_GET_OFFICTIME } from "../api/officetime.service";
 

// Initial state for office times
const initialState = {
  officeTimes: [],         
  loading: false,          
  selectedTime: null,       
};

// Async thunk to fetch office times
export const getOfficeTimes = createAsyncThunk(
  'officeTime/getOfficeTimes',
  async (_, thunkAPI) => {
    try {
      const response = await API_GET_OFFICTIME();   
      return response;  
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);   
    }
  }
);

// Async thunk to add a new office time
export const addOfficeTime = createAsyncThunk(
  'officeTime/addOfficeTime',
  async (configData, thunkAPI) => {
    try {
      const response = await API_ADD_OFFICETIME(configData);  
      return response;   
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);   
    }
  }
);

const officeTimeSlice = createSlice({
  name: "officeTime",
  initialState,
  reducers: {
    selectTime: (state, action) => {
      state.selectedTime = action.payload;   
    },
    resetSelectedTime: (state) => {
      state.selectedTime = null;  
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getOfficeTimes.fulfilled, (state, action) => {
      state.officeTimes = action.payload;  
      state.loading = false;
    });
    builder.addCase(getOfficeTimes.pending, (state) => {
      state.loading = true;  
    });
    builder.addCase(getOfficeTimes.rejected, (state) => {
      state.loading = false;  
    });
  }
});

export const { selectTime, resetSelectedTime } = officeTimeSlice.actions;

export default officeTimeSlice.reducer;
